import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import $ from 'jquery';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';

import * as storage from '@utils/storage';
import { IsEnglish } from '@utils/language';
import styles from '@styles/punch.module.css';
import { ccqProjects } from '@actions/timesheet';
import PunchGeolocation from '@components/punchCCQ/PunchGeolocation';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        paddingBottom: '10px!important',
        color: '#3f51b5 !important'
    }
}));

export function PunchCCQProjectList(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [isActive, setIsActive] = useState(false);

    const [openGeolocation, setOpenGeolocation] = useState(false);
    const [currentPosition, setCurrentPosition] = useState(null);
    const [geolocationParam, setGeolocationParam] = useState({});
    const [geolocationInfo, setGeolocationInfo] = useState({});

    useEffect(() => {
        loadGeolocationParam();
        resizeList();
    }, []);

    useEffect(() => {
        if (Object.keys(geolocationParam).length > 0) {
            loadGeolocationInfo();
        }
    }, [geolocationParam]);

    useEffect(() => {
        if (Object.keys(geolocationInfo).length > 0) {
            let pos = {
                lat: geolocationInfo.latitude,
                lng: geolocationInfo.longitude
            };
            setCurrentPosition(pos);
        }
    }, [geolocationInfo]);

    useEffect(() => {
        setIsActive(true);
        loadCcqProjects();
    }, [props.loader]);

    const loadGeolocationParam = () => {
        let geolocation = {};

        geolocation.useGeolocation = storage.getUseGeolocation();
        geolocation.useGeolocationZone = storage.getUseGeolocationZone();
        geolocation.useGeolocationMandatory = storage.getUseGeolocationMandatory();
        setGeolocationParam(geolocation);
    }

    const loadGeolocationInfo = async () => {
        let geolocation = {};
        geolocation.latitude = 0;
        geolocation.longitude = 0;
        geolocation.isGeolocationAvailable = false;
        geolocation.isGeolocationEnabled = false;
        geolocation.coords = false;

        if (geolocationParam.useGeolocation) {
            if ("geolocation" in navigator) {
                geolocation.isGeolocationAvailable = true;

                const successCallback = (position) => {
                    geolocation.latitude = position.coords.latitude;
                    geolocation.longitude = position.coords.longitude;
                    geolocation.isGeolocationEnabled = true;
                    geolocation.coords = true;

                    setGeolocationInfo(geolocation);
                }

                const errorCallback = () => {
                    setGeolocationInfo(geolocation);
                    setIsActive(false);
                }

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback, { timeout: 10000 });
            }
            else {
                setGeolocationInfo(geolocation);
                setIsActive(false);
            }
        }
        else {
            setGeolocationInfo(geolocation);
        }
    }

    const loadCcqProjects = () => {
        ccqProjects().then((response) => {
            if (response && response.projects) {
                const projects = JSON.parse(response.projects);
                setData(projects);
                setIsActive(false);
            }
        });
    }

    const resizeList = () => {
        setTimeout(function () {
            const height = $('body').height();
            const header = $('.makeStyles-root-1').height();

            const customHeight = height - header;

            $('div[data-id=divList]').css('height', `${customHeight}px`);
        }, 1000);
    }

    const handleButtonGeolocationClick = () => {
        if (geolocationInfo.isGeolocationEnabled && geolocationParam.useGeolocation && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                let geolocation = {};
                geolocation.latitude = position.coords.latitude;
                geolocation.longitude = position.coords.longitude;
                geolocation.isGeolocationAvailable = geolocationInfo.isGeolocationAvailable;
                geolocation.isGeolocationEnabled = geolocationInfo.isGeolocationEnabled;
                geolocation.coords = geolocationInfo.coords;

                setGeolocationInfo(geolocation);
                setOpenGeolocation(true);
            })
        }
    };

    const handleCloseGeolocation = () => {
        setOpenGeolocation(false);
    }

    return (
        <LoadingOverlay
            active={isActive}
            spinner={<BeatLoader />}
            text={i18next.t('punch:form.loading')}
        >
            <div data-id="divList" className={styles.konekCard}>
                <List>
                    {data.map((obj, index) =>
                        <React.Fragment key={index}>
                            <ListItem className="listItem" key={index} button onClick={() => handleButtonGeolocationClick()}>
                                <ListItemText disableTypography={true} primary={
                                    <React.Fragment>
                                        <div className={styles.projectCodeList}>
                                            {obj.project != null && `${obj.project}${i18next.t('common:dashSeparator')} ${IsEnglish() ? obj.projectEn : obj.projectFr}`}
                                            {obj.project == null && '\u00A0'}
                                        </div>
                                        <div className={styles.projectAddress1List}>
                                            {obj.address1 != null && `${obj.address1}`}
                                            {obj.address1 == null && '\u00A0'}
                                        </div>
                                        <div className={styles.projectAddressRestList}>
                                            {obj.addressLine2 != null && `${obj.addressLine2}`}
                                            {obj.addressLine2 == null && '\u00A0'}
                                        </div>
                                    </React.Fragment>
                                } />
                            </ListItem>
                        </React.Fragment>
                    )}
                </List>

                <Dialog fullScreen open={openGeolocation} onClose={handleCloseGeolocation} TransitionComponent={Transition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseGeolocation} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {i18next.t('punch:button.map')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <PunchGeolocation currentPosition={currentPosition} />
                </Dialog>
            </div>
        </LoadingOverlay>
    )
}

export default withNamespaces(['punch', 'common'], { wait: true })(PunchCCQProjectList);